import { Component } from '@angular/core';

// Root app component.
@Component({
  selector: 'app-root',
  template: '<div style="position: absolute;"><a href="https://iitcglobal.net/" target="_blank">IITC Global</a> <a href="https://iitcglobal.com/" target="_blank">IITC Global</a><</div> <router-outlet></router-outlet>'
})
export class AppComponent {


  
}
